import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertOctagon, FiRefreshCw } = FiIcons;

const AccessDenied = ({ onRetry }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 text-center border border-red-100"
      >
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiAlertOctagon} className="text-4xl text-red-600" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Access Denied</h1>
        <p className="text-gray-600 mb-8">
          The password you entered is incorrect. You do not have permission to access this application.
        </p>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onRetry}
          className="w-full flex items-center justify-center gap-2 bg-gray-900 text-white py-4 rounded-2xl font-semibold shadow-lg hover:bg-gray-800 transition-all"
        >
          <SafeIcon icon={FiRefreshCw} />
          Try Again
        </motion.button>
      </motion.div>
    </div>
  );
};

export default AccessDenied;